import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getNewsLetterEmails } from "../../actions/newsLetterActions";
const NewsLetter = () => {
  const { newsLetterEmail } = useSelector((state) => state.newsLetterState);
  const [itemOffset, setItemOffset] = useState(0);
  const dispatch = useDispatch();
  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(getNewsLetterEmails);
  }, [dispatch]);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = newsLetterEmail?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil((newsLetterEmail?.length || 0) / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % newsLetterEmail?.length;
    setItemOffset(newOffset);
  }
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {currentItems &&
            currentItems?.map((data, index) => {
              return (
                <tr key={`${data}-${itemOffset + index}`}>
                  <td className="query_name">{itemOffset + index + 1}</td>
                  <td className="query_email">{data}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
    </div>
  );
}

export default NewsLetter;

